(function() {
  'use strict';

  angular
    .module('traineeWebApp.services')
    .service('textLengthIndicatorState', textLengthIndicatorState);

  textLengthIndicatorState.$inject = [];

  function textLengthIndicatorState() {
    var states = {
      under: {
        test: function(txtLen, minLen, maxLen) {
          return txtLen < minLen;
        },
        style: 'inputLengthIndicatorOver',
        text: function(txtLen, minLen, maxLen) {
          return '-' + (minLen - txtLen).toString();
        },
        lengthValid: false,
        dataValid: true
      },
      ok: {
        test: function(txtLen, minLen, maxLen) {
          return txtLen >= minLen && txtLen < (maxLen - 10);
        },
        style: 'inputLengthIndicatorOff',
        text: function(txtLen, minLen, maxLen) {
          return '';
        },
        lengthValid: true,
        dataValid: true
      },
      near: {
        test: function(txtLen, minLen, maxLen) {
          return txtLen >= (maxLen - 10) && txtLen < maxLen;
        },
        style: 'inputLengthIndicatorNear',
        text: function(txtLen, minLen, maxLen) {
          return txtLen + ' / ' + maxLen;
        },
        lengthValid: true,
        dataValid: true
      },
      at: {
        test: function(txtLen, minLen, maxLen) {
          return txtLen == maxLen;
        },
        style: 'inputLengthIndicatorAt',
        text: function(txtLen, minLen, maxLen) {
          return txtLen + ' / ' + maxLen;
        },
        lengthValid: true,
        dataValid: true
      },
      over: {
        test: function(txtLen, minLen, maxLen) {
          return txtLen > maxLen;
        },
        style: 'inputLengthIndicatorOver',
        text: function(txtLen, minLen, maxLen) {
          return txtLen + ' / ' + maxLen;
        },
        lengthValid: false,
        dataValid: true
      }
    };

    this.resetStates = function() {
      states.ok.dataValid = true;
      states.near.dataValid = true;
      states.over.dataValid = true;
    };

    this.defaultState = states.ok;

    this.getState = function(forText, txtLengths) {
      txtLengths = _.isNumber(txtLengths) ? { max: txtLengths, min: 0 } : txtLengths;

      forText = forText || '';
      var txtLen = forText.length;

      for (var key in states) {
        if (states[key].test(txtLen, txtLengths.min, txtLengths.max)) {
          return {
            style: states[key].style,
            text: states[key].text(txtLen, txtLengths.min, txtLengths.max),
            lengthValid: states[key].lengthValid,
            dataValid: states[key].dataValid
          }
        }
      }

      return {};
    };
  }

})();
